import React from 'react';
import { Button } from 'antd';
import Text from 'components/Text/Text';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './AddNewReportBtn.module.scss';

interface IAddNewReportBtn {
	addNewReport: () => void;
}

const AddNewReportBtn: React.FC<IAddNewReportBtn> = ({ addNewReport }) => {
	return (
		<div className={style.container}>
			<Button
				className={style.button}
				type="text"
				onClick={addNewReport}
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#plus`} />
					</svg>
				}>
				<Text translationNameSpace="form" translationKey="addNewReportButton" asFragment={true} />
			</Button>
		</div>
	);
};

export default React.memo(AddNewReportBtn);
